import { API } from '../api.js';
import { useEffect, useState } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import CommunityPublicPage from './CommunityPublicPage';

export default function CommunityPage() {
  const { slug }            = useParams();
  const { user, token, loading: authLoading } = useAuth();
  const navigate            = useNavigate();

  const [community,    setCommunity]    = useState(null);
  const [membership,   setMembership]   = useState(null); // { isMember, role, joined_at }
  const [pageLoading,  setPageLoading]  = useState(true);
  const [error,        setError]        = useState('');

  useEffect(() => {
    if (authLoading) return;
    setPageLoading(true);

    const fetchCommunity = fetch(`${API}/api/communities/${slug}`)
      .then(r => r.ok ? r.json() : Promise.reject('Not found'));

    const fetchMembership = user && token
      ? fetch(`${API}/api/communities/${slug}/membership`, { headers: { Authorization: `Bearer ${token}` } })
          .then(r => r.ok ? r.json() : { isMember: false })
      : Promise.resolve({ isMember: false });

    Promise.all([fetchCommunity, fetchMembership])
      .then(([comm, mem]) => { setCommunity(comm); setMembership(mem); })
      .catch(() => setError('Community not found'))
      .finally(() => setPageLoading(false));
  }, [slug, user, token, authLoading]);

  if (authLoading || pageLoading) return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text3)', fontSize:15 }}>
      Loading…
    </div>
  );

  if (error) return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:16 }}>
      <div style={{ fontSize:48 }}>🔍</div>
      <div style={{ fontSize:20, fontWeight:700, color:'var(--text)' }}>Community not found</div>
      <div style={{ fontSize:14, color:'var(--text3)' }}>The community "{slug}" doesn't exist.</div>
      <button onClick={() => navigate('/')} style={{ padding:'10px 24px', borderRadius:10, border:'none', background:'var(--accent)', color:'#fff', cursor:'pointer', fontWeight:700, fontSize:14 }}>
        Browse communities
      </button>
    </div>
  );

  // Joined members go to the full tabbed community experience (slug-based URLs).
  if (user && membership?.isMember) {
    return <Navigate to={`/${community.slug || community.id}/community`} replace />;
  }

  // Everyone else sees the public about page
  return (
    <CommunityPublicPage
      community={community}
      onJoin={() => setMembership({ isMember: true, role: 'member', joined_at: new Date().toISOString() })}
    />
  );
}
